<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2019-09-20 13:36:29
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id='page_Container' class='choiceType'>
        <div class="page">
            <div id='main-container' class="main-container">
                <div class='goodsList'>
                    <van-row>
                        <van-col span="6" class='GoodInfo' v-for='item in dataRefund.refundOrderItemList' :key='item.id'>
                            <img :src="item.productImg" alt="">
                            <p>¥{{item.productPrice}}</p>
                        </van-col>
                    </van-row>
                </div>
                <div class='openUrl'>
                    <van-cell-group>
                        <van-cell title="" value="" v-for='item in refundTypeData' :key='item.id' is-link @click='openRefund(item.type)'>
                            <template slot='title'>
                                <img :src="item.refundUrl" alt="">
                            </template>
                            <div class='refundTypeStyle'>
                                <h5>{{item.h5Text}}</h5>
                                <p>{{item.pText}}</p>
                            </div>
                        </van-cell>
                    </van-cell-group>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
// import { toastLoading, clearToastLoading } from '@/utils/base/utils';
export default {
    data() {
        return {
            commodityUrl: require('../assets/img/myCenter/commodity.png'),
            chooseUrl: require('../assets/img/myCenter/choose.png'),
            dataRefund: {},
            orderItemJsonList: {},
            refundTypeData: [
                {
                    id: 1,
                    type: '1',
                    refundUrl: require('../assets/img/myCenter/refund.png'),
                    h5Text: '仅退款',
                    pText: '未收到货（包含未签收）或客服协商同意前提下'
                },
                {
                    id: 2,
                    type: '2',
                    refundUrl: require('../assets/img/myCenter/refundOr.png'),
                    h5Text: '退货退款',
                    pText: '已收到货，需要退换已收到的货物'
                }
            ]
        };
    },
    esvReady() {
        const ths = this;
        document.title = '选择服务类型';
        this.ESVStorage.getSavedValue('dataRefund', (data) => {
            ths.dataRefund = data;
        });
        this.ESVStorage.getSavedValue('orderItemJsonList', (data) => {
            ths.orderItemJsonList = data;
        });
    },
    esvShow() {
    },
    methods: {
        openRefund(type) {
            this.esvOpenPage({ name: 'OPRefund', query: { type: type } });
        },
        // 查询详情
        queryMemberOrderItemForRefund(orderCode) {
            const ths = this;
            const params = {
                orderCode: ths.dataRefund.memberOrderItemList[0].orderCode,
                orderItemJsonList: JSON.stringify(ths.orderItemJsonList),
                merchantInfo: JSON.stringify(this.merchantInfoSwitch)
            };
            ths.$doRequest(
                {
                    url: '/order/queryMemberOrderItemForRefund',
                    params: params,
                    complete: function() {}
                },
                function(data) {
                    ths.ESVStorage.putSavedValue(
                        'dataRefund',
                        data.result
                    );
                }
            );
        }
    },
    computed: {
        ...mapGetters([
            'merchantInfoSwitch'
        ])
    }
};
</script>
<style lang="scss" scoped>
.goodsList {
    padding: 12px;
    background: #fff;
    .GoodInfo {
        position: relative;
        text-align: center;
        display: flex;
        img {
            width: 90px;
            height: 90px;
        }
        p {
            background: rgba(0, 0, 0, 0.5);
            color: white;
            text-align: center;
            height: 24px;
            line-height: 24px;
            position: absolute;
            bottom: 0;
            width: 90px;
        }
    }
}
.openUrl {
    padding: 0 12px;
    background: #fff;
    margin-top: 12px;
    h5 {
        color: #414141;
    }
    .van-cell {
        padding: 10px 0;
    }
    img {
        width: 22px;
    }
}
.refundTypeStyle {
    text-align: left;
    padding-left: 15px;
}
</style>
